import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["list"];

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      animation: 150,
      handle: ".drag-handle",
      onEnd: this.end.bind(this),
    });
  }

  end(event) {
    const id = event.item.dataset.id;
    const newPosition = event.newIndex;

    // Send the new position to the server
    fetch(this.element.dataset.sortableUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify({
        exercise: {
          id: id,
          position: newPosition,
        },
      }),
    });
  }
}
